var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-ad",domProps:{"innerHTML":_vm._s(_vm.articleAd)}})
}
var staticRenderFns = []

export { render, staticRenderFns }